import angular from 'angular';
import '../../services/videos';
import '../../services/errors';
import '../../services/notifications';
import { cloneDeep } from 'lodash';

const module = angular.module('whyline.modals.videos', [
  'whyline.services.videos',
  'whyline.services.errors',
  'whyline.services.notifications',
]);

const VideosModalController = ($scope, $timeout, $translate, $uibModalInstance, currentVideo, placeId, VideosService, NotificationService, ErrorService) => {
  'ngInject';

  if(currentVideo) {
    $scope.video = cloneDeep(currentVideo);
  } else {
    $scope.video = {
      name: '',
      src: '',
    };
  }

  const validate = () => {
    const name = $scope.video.name;
    const src = $scope.video.src;

    if(!name) {
      NotificationService.Warning($translate.instant('mandatory_video_name'));
      return false;
    }

    if(!src) {
      NotificationService.Warning($translate.instant('mandatory_video_src'));
      return false;
    }

    if(!/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/.test(src.toLowerCase())) {
      NotificationService.Warning($translate.instant('url regex'));
      return false;
    }

    return true;
  };

  $scope.save = () => {
    if(validate()) {
      if($scope.video._id) {
        return VideosService.Update({
          ...$scope.video,
        })
        .then(() => {
          NotificationService.Success($translate.instant('video_update_succ'));
          $uibModalInstance.close('cancel');
        })
        .catch(ErrorService.handler);
      }

      return VideosService.Create($scope.video)
        .then(() => {
          NotificationService.Success($translate.instant('video_create_succ'));
          $uibModalInstance.close('cancel');
        })
        .catch(ErrorService.handler);
    }
  };

  // Close modal
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };
};

module.exports = module.controller('VideosModalController', VideosModalController);
